import { IComponentOptions } from "angular";
import { FilterOrganizationController } from "./filter.organization.controller";

angular.module("thor.loki.filter.organization.component", []).component("lokiFilterOrganization", <IComponentOptions>{
    bindings: {
        organization: "=",
        membership: "="
    },
    controller: FilterOrganizationController,
    controllerAs: "filterOrganizationCtrl",
    template: require("./filter.organization.html")
});
